export enum Roles {
  // 游客
  Guest = 0,
  // 超级管理员  1 << 0
  Admin = 1,
  // 总渠道负责人 1 << 1
  HeadChannelManager = 2,
  //  渠道负责人 1 << 2
  ChannelManager = 4,
  // 团队成员 1 << 3
  Members = 8,
}

export type PermissionMapKey = keyof typeof modulesPermission

export type PermissionMap = Record<PermissionMapKey, Roles | number>

export const modulesPermission = {
  // 首页利润数据
  HomeProfitData: Roles.HeadChannelManager,
  // 首页预计佣金
  // HomeCommissionSituation: Roles.HeadChannelManager | Roles.ChannelManager | Roles.Members,
  // 首页当月佣金
  HomeCurrentMonthlyCommission: Roles.Members,
  // 首页实际佣金
  // HomeCommissionPayment: Roles.HeadChannelManager | Roles.ChannelManager | Roles.Members,
  // 首页机会项目
  HomeOpportunityProject: Roles.Members,
  // 设置客户目标
  CustomerTarget: Roles.Members,
  // 客户利润情况
  CustomerProfitData: Roles.HeadChannelManager,
  // 客户订单tab
  CustomerOrderTab: Roles.ChannelManager | Roles.Members,
  // 佣金确认账单功能
  CommissionConfirm: Roles.Members,
  // 团队目标管理模块，设置目标功能
  ObjectivesTarget: Roles.HeadChannelManager,
  // 团队目标管理模块，显示目标利润
  ObjectivesProfit: Roles.HeadChannelManager,
  // 团队目标管理模块，设置关联客户
  ObjectivesRelatedCustomer: Roles.HeadChannelManager,
  // 团队列表允许设置 User Role
  TeamListSetUserRole: Roles.Admin,
  // 销售地图 broker 权限
  SalesMapBroker: Roles.Members | Roles.Guest,
}
